import { slugify as slugifyCore } from '@superbet-group/web.lib.utilities';

import i18n from '@app/localization/i18n';

export function slugify(text: string, options = { translate: true }): string {
    if (options.translate) {
        return slugifyCore(i18n.t(text).toString());
    }
    return slugifyCore(text);
}
